/* eslint @typescript-eslint/no-use-before-define: ["error", { "functions": false }] */
import { dataLayer, pushEvent, pushOnce } from "utils/data-layer"

const SCROLL_DISTANCE = 8
const SCROLL_KEYS = ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", " "]
const INPUT_EVENTS = ["pointerdown", "touchstart", "wheel"]

function observeSnowfall(row, track) {
  if (!row || !window.IntersectionObserver) return

  let visible = false
  let inputSeen = false
  let scrolled = false
  let startY = window.scrollY
  let observer

  function removeInputListeners() {
    INPUT_EVENTS.forEach((name) => document.removeEventListener(name, onInput))
    document.removeEventListener("keydown", onKey)
  }

  function onInput() {
    startY = window.scrollY
    inputSeen = true
    removeInputListeners()
  }

  function onKey(event) {
    if (SCROLL_KEYS.includes(event.key)) onInput()
  }

  function checkVisibility() {
    if (!visible || document.visibilityState !== "visible") return

    track("forecast_table_in_view")
    if (!scrolled) return

    track("scrolled_to_forecast_table")
    observer.disconnect()
    window.removeEventListener("scroll", onScroll)
    document.removeEventListener("visibilitychange", checkVisibility)
    removeInputListeners()
  }

  function onScroll() {
    if (inputSeen && Math.abs(window.scrollY - startY) >= SCROLL_DISTANCE) scrolled = true
    checkVisibility()
  }

  // Unsupported browsers skip visibility tracking via the guard above.
  // eslint-disable-next-line compat/compat
  observer = new IntersectionObserver(([entry]) => {
    visible =
      entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0
    checkVisibility()
  })

  observer.observe(row)
  INPUT_EVENTS.forEach((name) => document.addEventListener(name, onInput, { passive: true }))
  document.addEventListener("keydown", onKey)
  window.addEventListener("scroll", onScroll, { passive: true })
  document.addEventListener("visibilitychange", checkVisibility)
}

export default function forecastEngagement() {
  const context = dataLayer().find((entry) => entry.page_type)
  const container = document.getElementById("forecast-table")
  const content = container?.querySelector(".forecast-table__content")
  if (
    !content ||
    !["forecast_guests", "forecast_members"].includes(context?.page_type) ||
    context.disableGA === "yes"
  ) {
    return {}
  }

  function track(event, params = {}) {
    try {
      pushOnce(event, () => {
        pushEvent(event, {
          page_type: context.page_type,
          active_membership: context.active_membership,
          userType: context.userType,
          resort: context.resort,
          resort_country: context.resort_country,
          forecast_elevation: window.FCGON.level,
          ...params,
        })
      })
    } catch {
      // Analytics failures must not interrupt forecast interactions.
    }
  }

  const startX = content.scrollLeft
  function onHorizontalScroll() {
    if (Math.abs(content.scrollLeft - startX) < SCROLL_DISTANCE) return

    track("forecast_table_hscroll")
    content.removeEventListener("scroll", onHorizontalScroll)
  }
  content.addEventListener("scroll", onHorizontalScroll, { passive: true })

  function onElevationClick(event) {
    const link = event.target.closest("a[data-forecast-elevation]")
    const elevation = link?.dataset.forecastElevation
    if (!elevation || elevation === window.FCGON.level) return

    track("forecast_elevation_select", { to_elevation: elevation })
    document.removeEventListener("click", onElevationClick)
  }
  document.addEventListener("click", onElevationClick)

  observeSnowfall(container.querySelector('tr[data-row="snow"]'), track)

  return {
    onDetailIncrease(detail, level) {
      if (detail === 1) track("forecast_expand_3h", { forecast_elevation: level })
      if (detail === 2) track("forecast_expand_1h", { forecast_elevation: level })
    },
    onHindcastRequest(level) {
      track("forecast_hindcast_request", { forecast_elevation: level })
    },
  }
}
